module.exports = __webpack_public_path__ + "static/media/pexels-2.87c783e8.jpg";